import React from 'react';
import AppleGame from '../../features/apps/components/AppleGame';

const AppleGameRoute = () => {
  return <AppleGame />;
};

export default AppleGameRoute;
